module.exports = "/assets/8a2be081832ff3dbe706916760bfed7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/A2.png
// module id = 1180
// module chunks = 0